
<template>
  <el-input
    v-model="state.input"
    placeholder="请输入内容"
    class="input-with-select"
    :class="{ 'has-select': sortData.length > 0 }"
    @keyup.enter="search"
    v-bind="attrs"
    :disabled="disabled"
    :maxlength="limit"
  >
    <template
      v-if="sortData.length > 0"
      #prepend
    >
      <el-select
        v-model="state.select"
        placeholder="全部"
        style="width: 110px"
      >
        <el-option
          v-for="item in sortData"
          :label="item.label"
          :value="item.value"
          :key="item.value"
        ></el-option>
      </el-select>
    </template>
    <template #append>

      <el-button
        @click="search"
        :size="attrs.size"
      >
        <el-icon>
          <Search />
        </el-icon>
      </el-button>
    </template>
  </el-input>
</template>

<script setup>
import { reactive } from "vue";
import { Search } from "@element-plus/icons-vue";
import { useAttrs } from "element-plus";

const emit = defineEmits(["doSearch"]);
const attrs = useAttrs();
const props = defineProps({
  sortData: {
    type: Array,
    default: () => {
      return [];
    },
  },
  limit: {
    // 可输入内容长度限制
    type: Number,
    default: 1000,
  },
  disabled: {
    type: Boolean,
    default: false
  }
});

const state = reactive({
  select: "",
  input: "",
});
const search = () => {
  let params = {
    searchValue: state.input,
  };
  if (props.sortData.length) {
    params.searchKey = state.select;
  }
  emit("doSearch", params);
};
</script>

<style lang="less" scoped>
.input-with-select {
  width: 280px;
  background: #fff;
  &.has-select {
    width: 372px;
  }
  &.el-input--small {
    :deep(.el-input__inner) {
      height: 28px;
    }
  }

  :deep(.el-input__prefix-inner) {
    text-align: center;
    .iconfont {
      color: #3d404a;
      margin-left: 10px;
    }
  }

  :deep(.el-input-group__append) {
    background: @themePrimaryColor;
    color: #fff;
    box-shadow: none;
    padding: 0 12px;
    .el-icon {
      font-size: 16px;
    }
  }

  :deep(.el-input__wrapper) {
    box-shadow: 0 0 0 1px #CBD6ED inset;
    .el-input__inner::placeholder {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #A4B2CE;
      line-height: 20px;
    }
  }
}
</style>
